<app-breadcrumb [title]="page_name" [breadcrumb]="page_name" [currentUrl]="currentUrl"></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
    <div class="container">
        <div class="row">
            <div class="col-sm-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <button class="popup-btn">
                        {{'my account' | translate}}
                    </button>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back' | translate}}
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <ul>
                                <li><a data-lng="es" [routerLink]="'/pages/dashboard'">
                                        {{'address' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-orders'">
                                        {{'orders' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-coupones'">
                                        {{'coupones' | translate}}
                                    </a>
                                </li>
                                <li class="active"><a data-lng="es" [routerLink]="'/pages/browse-log'">
                                        {{'browse log' | translate}}
                                    </a>
                                </li>
                               

                                <li><a data-lng="es" [routerLink]="'/pages/profile'">
                                        {{'my profile' | translate}}
                                    </a>
                                </li>
                                <li>
                                    <a data-lng="es" href="javascript:void(0)" (click)="userLogOut()">

                                        {{'logout' | translate}}
                                    </a>
                                </li>

                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="mt-3 col-sm-9">
                

                <section class="wishlist-section section-b-space">
                    <div class="container">

                        <div class="row wishlist-buttons" *ngIf='products.length && finished'>
                            <div class="col-12">
                                <!-- <a [routerLink]="['/']" class="btn btn-solid">{{'continue shopping' | translate}}</a> -->
                                <button (click)="clearAllBrowseHistory()"
                                    class="btn btn-solid clear-all-button">{{'clear all' | translate}}
                                </button>
                                <!-- <a [routerLink]="['/shop/checkout']"
                                    class="btn btn-solid">{{'clear all' | translate}}
                                </a> -->
                            </div>
                        </div>

                        <div class="text-center col-md-12 empty-cart-cls" *ngIf='!products.length && finished'>
                            <img src="assets/images/empty-compare.png" alt="Empty cart" title="Emprt cart">
                            <h3 class="mt-4"><b>{{'browse history empty' | translate}}</b></h3>
                            <h4></h4>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-center">
                            <img src="assets/images/loader.gif" *ngIf="!finished">
                        </div>
                        <div class="row" *ngIf='products.length && finished' infiniteScroll
                            [infiniteScrollDistance]="3" [infiniteScrollThrottle]="300" (scrolled)="onScroll()">
                            
                            <div class="mobile-logs-list-layout">
                                <app-browse-log-item class="single-log-item" (listUpdated)="removeItem(product.id, index)" *ngFor="let product of products ; let index = index" [product]="product"></app-browse-log-item>
                            </div>
                            
                            <div class="col-sm-12 table-layout">
                                <table class="table cart-table table-responsive-xs">
                                    <thead>
                                        <tr class="table-head">
                                            <th scope="col">{{'image' | translate}}</th>
                                            <th class="name" scope="col">{{'Product Name' | translate}}</th>
                                            <th scope="col">{{'Price' | translate}}</th>
                                            <th scope="col">{{'browse_date' | translate}}</th>
                                            <!-- <th scope="col">availability</th> -->
                                            <th scope="col">{{'ACTION' | translate}}</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let product of products ; let index = index" >
                                        <tr>
                                            <td>
                                                <a [routerLink]="['/shop/product/', product.id , product.meta_url ? product.meta_url.split(' ').join('-') : removeBrackets(product.name).split(' ').join('-')]" >
                                                    <img [src]="urlimage+product.original_image" [alt]="product.name" (error)="handleImageError($event.target)">
                                                </a>
                                            </td>

                                            <td style="text-align: start;">
                                                <a
                                                    [routerLink]="['/shop/product/', product.id , product.meta_url ? product.meta_url.split(' ').join('-') : removeBrackets(product.name).split(' ').join('-')]">{{ product.name | titlecase }}
                                                </a>
                                                <div class="mobile-cart-content row">
                                                    <!-- <div class="col-xs-3">
                                                        <p>{{ product.store_amounts > 0 ? 'in stock' : 'out of stock' }}
                                                        </p>
                                                    </div> -->
                                                    <div class="mb-2 col-xs-3">
                                                        <p>{{ product.history_date_added_since }}
                                                        </p>
                                                    </div>
                                                    <div class="mb-2 col-xs-3">
                                                        <h2 class="td-color">
                                                            {{ (product.price | discount:product) * productService?.Currency.price | currency:productService?.Currency.currency:'symbol' }}
                                                        </h2>
                                                    </div>
                                                    <div class="mb-2 col-xs-3">
                                                        <h2 class="td-color">
                                                            <a href="javascript:void(0)"
                                                                (click)="removeItem(product.history_id, index)"
                                                                class="mb-1 mr-1 icon">
                                                                <i class="ti-close"></i>
                                                            </a>
                                                            <a [routerLink]="['/shop/cart']"
                                                                (click)="addToCart(product)" class="cart">
                                                                <i class="ti-shopping-cart"></i>
                                                            </a>
                                                        </h2>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <h2>
                                                    {{ (product.price | discount:product) * productService?.Currency.price  }}
                                                    {{productService?.Currency.name}}
                                                </h2>
                                            </td>
                                            <!-- DATE ADDED -->
                                            <td>
                                                <h2>
                                                    
                                                    {{ product.history_date_added | fromNowMoment }}
                                                    
                                                </h2>
                                            </td>

                                            <td class="actions-cell">
                                                <a href="javascript:void(0)" (click)="addToCart(product)" class="cart">
                                                    <i class="fa fa-cart-plus" aria-hidden="true"></i>

                                                </a>
                                                &nbsp;/&nbsp;
                                                <a href="javascript:void(0)"
                                                    (click)="removeItem(product.id, index)"
                                                    class="mr-3 icon">
                                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-center">
                            <img src="assets/images/loader.gif" *ngIf="loading">
                        </div>
                        
                        
                    </div>
                </section>
                

            </div>
        </div>
    </div>
</section>

<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>